import { render, staticRenderFns } from "./CreateBlacklist.vue?vue&type=template&id=b236bcbc&scoped=true&"
import script from "./CreateBlacklist.vue?vue&type=script&lang=js&"
export * from "./CreateBlacklist.vue?vue&type=script&lang=js&"
import style0 from "./CreateBlacklist.vue?vue&type=style&index=0&id=b236bcbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b236bcbc",
  null
  
)

export default component.exports